import numeral from 'numeral'

export const getRegionText = (name: string) => name

export const getAggregateDollarsText = (name: string, value: number) => {
    const label = name ? `${name}: ` : ''
    return `<br />${label}<span class="currency-symbol-span">${imod.cms.scoreboards.verbiage.globalCurrencySymbol}</span>${numeral(value).format()}`
}

export const getUniqueCountText = (name: string, value: number) => {
    const label = name ? `${name}: ` : ''
    return `<br />${label}${numeral(value).format()}`
}
